document.addEventListener("DOMContentLoaded", function () {
  const endDateElement = document.getElementById("timer");
  const endDate = new Date(endDateElement.dataset.endDateTime).getTime();
  const intervalDuration = 6 * 60 * 60 * 1000; // 6 hours in milliseconds

  function formatTime(time) {
    return time < 10 ? "0" + time : time;
  }

  function calculateNextRestartTime() {
    const now = new Date();
    const startOfDay = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      0,
      0,
      0
    );
    const elapsedMilliseconds = now - startOfDay;
    const intervalsPassed = Math.floor(elapsedMilliseconds / intervalDuration);
    const nextRestartTime =
      startOfDay.getTime() + (intervalsPassed + 1) * intervalDuration;
    return nextRestartTime;
  }

  let nextRestartTime = calculateNextRestartTime();

  function countdown() {
    const now = Date.now();
    let timeLeft = nextRestartTime - now;

    if (timeLeft < 0) {
      nextRestartTime = calculateNextRestartTime();
      document.getElementById("status").textContent =
        "Timer restarted at: " + new Date().toLocaleString();
    }

    if (now >= endDate) {
      clearInterval(timerId);
      document.getElementById("status").textContent =
        "End date reached, stopping timer.";
      document.getElementById("countdown").innerHTML = "Timer stopped.";
      return;
    }

    let seconds = Math.floor((timeLeft / 1000) % 60);
    let minutes = Math.floor((timeLeft / (1000 * 60)) % 60);
    let hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
    let days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));

    let timerText = `<div style="display: inline-block; text-align: center; margin-right: 5px;">
                                    <div class="thetext">Days</div>
                                    <div class="thetime">${formatTime(
                                      days
                                    )}</div>
                                 </div>
                                 <div style="display: inline-block; text-align: center; margin-right: 5px;">
                                    <div class="thetext">Hours</div>
                                    <div class="thetime">${formatTime(
                                      hours
                                    )}</div>
                                 </div>
                                 <div style="display: inline-block; text-align: center; margin-right: 5px;">
                                    <div class="thetext">Minutes</div>
                                    <div class="thetime">${formatTime(
                                      minutes
                                    )}</div>
                                 </div>
                                 <div style="display: inline-block; text-align: center;">
                                    <div class="thetext">Seconds</div>
                                    <div class="thetime">${formatTime(
                                      seconds
                                    )}</div>
                                 </div>`;

    document.getElementById("countdown").innerHTML = timerText;
  }

  countdown();
  const timerId = setInterval(countdown, 1000);
});
